import C from "../constants";
const appLoading = (state = true, action) => {
  switch (action.type) {
    case C.SET_APP_LOADING:
      return action.payload;
    default:
      return state;
  }
};
export default appLoading;
